var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLorawan({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 15.25C13.7949 15.25 15.25 13.7949 15.25 12C15.25 10.2051 13.7949 8.75 12 8.75C10.2051 8.75 8.75 10.2051 8.75 12C8.75 13.7949 10.2051 15.25 12 15.25Z",
    stroke: "currentColor",
    strokeWidth: 1.7
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 15.25V21",
    stroke: "currentColor",
    strokeWidth: 1.7,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.15 6.55C7.65 7.48 6.65 9.11 6.65 12C6.65 14.89 7.65 16.52 9.15 17.45",
    stroke: "currentColor",
    strokeWidth: 1.7,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.85 6.55C16.35 7.48 17.35 9.11 17.35 12C17.35 14.89 16.35 16.52 14.85 17.45",
    stroke: "currentColor",
    strokeWidth: 1.7,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M6.15 4.05C3.85 5.85 2.5 8.55 2.5 12C2.5 15.45 3.85 18.15 6.15 19.95",
    stroke: "currentColor",
    strokeWidth: 1.7,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M17.85 4.05C20.15 5.85 21.5 8.55 21.5 12C21.5 15.45 20.15 18.15 17.85 19.95",
    stroke: "currentColor",
    strokeWidth: 1.7,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 12H13.5",
    stroke: "currentColor",
    strokeWidth: 1.7,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLorawan);
export default __webpack_public_path__ + "static/media/lorawan.0ae913750fd9766e34ab60fa3a33e029.svg";
export { ForwardRef as ReactComponent };